import { Trees, HardHat, LayoutGrid } from "lucide-react";
import { Reveal, Eyebrow } from "./Reveal";

const ITEMS = [
  { icon: Trees, title: "Kendi parkurumuz ve doğası var", text: "Çekmeköy Ormanları'nın doğal parkurlarında, şehrin hemen yanında sürüş." },
  { icon: HardHat, title: "Motor ve ekipman bizden", text: "Tesise ait motor, ekipman ve kıyafetlerle güvenle sür. Motorun olmasa da gel." },
  { icon: LayoutGrid, title: "Her şey tek yerde", text: "Eğitim, çocuk eğitimi, enduro tur ve kulüp üyeliği aynı yerde." },
];

export const WhyUs = () => (
  <section id="neden-biz" data-testid="why-section" className="border-y border-white/10 bg-surface">
    <div className="mx-auto max-w-7xl px-5 py-24 md:px-8 md:py-32">
      <Reveal>
        <Eyebrow>Neden FX</Eyebrow>
        <h2 className="max-w-3xl font-display text-5xl uppercase leading-none text-white md:text-6xl">Gel, giyin, sür. Gerisini biz hallederiz.</h2>
      </Reveal>
      <div className="mt-16 grid grid-cols-1 border-l border-t border-white/10 md:grid-cols-3">
        {ITEMS.map((it, i) => (
          <Reveal key={it.title} delay={i * 0.1} className="group border-b border-r border-white/10 p-8 transition-colors hover:bg-white/[0.03] md:p-10">
            <div data-testid={`why-item-${i}`}>
              <it.icon className="h-10 w-10 text-brand transition-transform group-hover:-translate-y-1" strokeWidth={1.5} />
              <h3 className="mt-8 font-display text-3xl uppercase leading-tight text-white">{it.title}</h3>
              <p className="mt-4 leading-relaxed text-neutral-400">{it.text}</p>
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
